import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import styles from '../styles.module.scss';
import { formatPrice, limitTextLength } from '@utils/utils';

export interface I_cardProps {
    imgSrcPC: string; // 圖片來源
    imgSrcM: string; // 圖片來源
    imgAlt: string; // 圖片ALT
    imgTitle: string; // 圖片Title
    productInfo: string; // 產品介紹
    productLink: string; // 產品連結
    price: number; // 產品價錢
    onErrImg: string;
}

const Card: React.FC<I_cardProps> = (props) => {
    const moduleName = 'card';
    const {
        imgSrcPC,
        imgSrcM,
        onErrImg,
        imgAlt,
        imgTitle,
        productInfo,
        productLink,
        price,
    } = props;
    const [imgErr, serImgErr] = useState<boolean>(false);
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    const displayImg = (() => {
        if (imgErr) return onErrImg;

        if (isMobile) {
            return imgSrcM ? imgSrcM : onErrImg;
        } else {
            return imgSrcPC ? imgSrcPC : onErrImg;
        }
    })();

    return (
        <div className={styles[`${moduleName}`]}>
            <div className={styles.CardWrap}>
                <a href={productLink}>
                    <div className={styles.Item_pic}>
                        <img
                            src={displayImg}
                            alt={imgAlt}
                            title={imgTitle}
                            onError={() => {
                                serImgErr(true);
                            }}
                        />
                    </div>
                    <div className={styles.Item_content}>
                        <div className={styles.Detail_title}>
                            <p title={productInfo}>{limitTextLength(productInfo, 60)}</p>
                        </div>
                        <div className={styles.Item_detail}>
                            <div className={styles.Price}>
                                <span>TWD</span>
                                <span className={styles.Number}>{formatPrice(price)}</span>
                                <span className={styles.Unit}>起</span>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    );
};

export default Card;
